import { http } from '@noor/api';
import { env } from '@noor/config';
import { lookupOptionSchema, type LookupOption } from '../model/lookup';
import { BUSINESS_LOOKUP_LIMIT } from '../config/media';

const eatsBase = { baseURL: env.VITE_EATS_API_URL };

function normalizeOptions(raw: unknown): LookupOption[] {
  const root =
    typeof raw === 'object' && raw !== null ? (raw as Record<string, unknown>) : {};
  const list = [root.list, root.items, root.results].find((value) =>
    Array.isArray(value),
  );
  if (!Array.isArray(list)) return [];
  const options: LookupOption[] = [];
  for (const item of list) {
    const parsed = lookupOptionSchema.safeParse(item);
    if (parsed.success) options.push(parsed.data);
  }
  return options;
}

export const businessLookupApi = {
  async searchRestaurants(
    name: string,
    merchantId?: string,
    limit: number = BUSINESS_LOOKUP_LIMIT,
  ): Promise<LookupOption[]> {
    const raw = await http.get<unknown>('/api/v1/admin/restaurants', {
      ...eatsBase,
      query: {
        ...(merchantId ? { merchant_id: merchantId } : {}),
        ...(name.trim() !== '' ? { name: name.trim() } : {}),
        'pagination.limit': String(limit),
        'pagination.offset': '0',
      },
    });
    return normalizeOptions(raw);
  },

  async searchProducts(name: string): Promise<LookupOption[]> {
    const raw = await http.get<unknown>('/api/v1/admin/products', {
      ...eatsBase,
      query: {
        ...(name.trim() !== '' ? { name: name.trim() } : {}),
        'pagination.limit': String(BUSINESS_LOOKUP_LIMIT),
        'pagination.offset': '0',
      },
    });
    return normalizeOptions(raw);
  },
};
